import React from 'react'
import { Link, Box } from '@chakra-ui/react'

export const BackToCoinPurchaseLink = ({ onClick }) => {
  return (
    <Box w="100%" py="16px" textAlign="center">
      <Link color="label.link" fontSize="sm" textDecoration="underline" lineHeight="18px" onClick={onClick} cursor="pointer">
        コイン購入画面へ戻る
      </Link>
    </Box>
  )
}
